import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import CapacityStatistics from 'src/features/routes/statistics/CapacityStatistics';
import GatewayStatistics from 'src/features/routes/statistics/GatewayStatistics';
import MonthlyPaymentStatistics from 'src/features/routes/statistics/MonthlyPaymentStatistics';
import PaymentStatistics from 'src/features/routes/statistics/PaymentStatistics';
import StatisticOptions from 'src/features/routes/statistics/StatisticOptions';
import UserActions from 'src/features/routes/statistics/UserActions';
import ValidationStatistics from 'src/features/routes/statistics/ValidationStatistics';
import VisitStatistics from 'src/features/routes/statistics/VisitStatistics';
import StatisticLayout from 'src/features/statistic/components/StatisticLayout';
import useHasPermissions from 'src/hooks/useHasPermissions';

const StatisticRoutes = () => {
    const accessPaymentsStatistics = useHasPermissions([PERMISSION.ACCESS_PAYMENT_STATISTICS]);
    const accessOccupancyStatistics = useHasPermissions([PERMISSION.ACCESS_OCCUPANCY_STATISTICS]);
    const accessValidationStatistics = useHasPermissions([PERMISSION.ACCESS_VALIDATION_STATISTICS]);
    const accessEventLogs = useHasPermissions([PERMISSION.ACCESS_EVENT_LOGS]);

    return (
        <Routes>
            <Route path="" element={<StatisticOptions />} />
            <Route path="" element={<StatisticLayout />}>
                {accessPaymentsStatistics && (
                    <>
                        <Route path="payment" element={<PaymentStatistics />} />
                        <Route path="monthly-payment" element={<MonthlyPaymentStatistics />} />
                    </>
                )}
                {accessOccupancyStatistics && (
                    <>
                        <Route path="visit" element={<VisitStatistics />} />
                        <Route path="capacity" element={<CapacityStatistics />} />
                        <Route path="gateway" element={<GatewayStatistics />} />
                    </>
                )}
                {accessValidationStatistics && <Route path="validation" element={<ValidationStatistics />} />}
                {accessEventLogs && <Route path="user-actions" element={<UserActions />} />}
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    );
};

export default StatisticRoutes;
